import { render, staticRenderFns } from "./ProviderStripeConfiguration.vue?vue&type=template&id=220a5a2d&"
import script from "./ProviderStripeConfiguration.vue?vue&type=script&lang=js&"
export * from "./ProviderStripeConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports